import { Button, styled } from '@moleculeone/ui';

import { AnalogsProps } from '../hooks/useAnalogs';

export const TextArea = styled('textarea', {
  'display': 'block',
  'width': '100%',
  'padding': '$5',
  'border': 'none',
  'borderRadius': '$medium',
  'boxShadow': 'hsl(206 22% 7% / 15%) 0px 5px 19px -5px, hsl(206 22% 7% / 15%) 0px 5px 10px -7px',
  'fontSize': '$3',
  '&:hover': {
    borderColor: '$purple6',
  },
  '&:focus, &:focus-visible': {
    borderColor: '$purple7',
    outline: 'none',
  },
});
const AnalogsPromptContainer = styled('div', {
  width: '20rem',
  paddingTop: '$5',
  paddingBottom: '$5',
  marginRight: '$5',
  display: 'flex',
  flexDirection: 'column',
});
const AnalogsPromptInput = styled('div', {
  position: 'relative',
  flex: 1,
});
const AnalogsPromptLabel = styled('label', {
  fontWeight: '500',
  display: 'block',
  marginBottom: '0.5rem',
});
const AnalogsPromptTextArea = styled(TextArea, {
  'height': '100%',
  '&:empty + div': {
    opacity: 1,
    pointerEvents: 'auto',
    transform: 'translateY(0)',
  },
});
const AnalogsPromptExamples = styled('div', {
  opacity: 0,
  pointerEvents: 'none',
  transform: 'translateY(-0.3rem)',
  transition: 'opacity .15s, transform .15s ease-out',
  position: 'absolute',
  inset: '$9 $3 auto $3',
  display: 'flex',
  flexDirection: 'column',
  gap: '$2',
});
const AnalogsPromptExample = styled(Button, {
  width: '100%',
});

const ANALOG_PROMPT_EXAMPLES = [
  'have better solubility in water',
  'have MW below 350Da',
  "wouldn't have the stability issue",
];

export function AnalogsPrompt(props: Pick<AnalogsProps, 'analogsPrompt' | 'setAnalogsPrompt'>) {
  const { analogsPrompt, setAnalogsPrompt } = props;

  return (
    <AnalogsPromptContainer>
      <AnalogsPromptLabel>Instructions (optional)</AnalogsPromptLabel>
      <AnalogsPromptInput>
        <AnalogsPromptTextArea
          placeholder="Suggest analogs that..."
          value={analogsPrompt}
          onChange={event => {
            setAnalogsPrompt(event.currentTarget.value);
          }}
        />
        <AnalogsPromptExamples>
          {ANALOG_PROMPT_EXAMPLES.map(example => (
            <AnalogsPromptExample
              key={example}
              theme="slate"
              weight="outlined"
              text={`... ${example}`}
              onClick={() => {
                setAnalogsPrompt(`Suggest analogs that ${example}`);
              }}
            />
          ))}
        </AnalogsPromptExamples>
      </AnalogsPromptInput>
    </AnalogsPromptContainer>
  );
}
